<template>
    <div
        class="hts-toolbar-top"
        :class="{ 'has-alert': alertVisible }">
        <div
            v-if="alertVisible && isTrucker"
            class="hts-toolbar-top__alert"
            :style="alertStyle">
            <template v-if="alertRoute">
                <nuxt-link
                    :to="alertRoute"
                    class="hts-toolbar-top__alert-content"
                    v-html="alertContent" />
            </template>
            <div
                v-else
                class="hts-toolbar-top__alert-content"
                v-html="alertContent" />
            <div class="hts-toolbar-top__alert-close-btn">
                <hts-icons
                    icon-name="hi-x-mark-icon"
                    @click="alertVisible = false" />
            </div>
        </div>
        <div class="hts-toolbar-top__container">
            <nav class="h-full flex justify-between items-center px-2 sm:px-4">
                <div class="flex w-full items-center gap-2">
                    <button
                        class="hidden max-lg:block"
                        type="button"
                        @click="openMenu">
                        <span class="sr-only">
                            Open sidebar
                        </span>
                        <hi-bars-3-icon
                            aria-hidden="true"
                            class="h-6 w-6" />
                    </button>
                    <router-link :to="{ name: 'index' }">
                        <div class="flex items-center justify-center">
                            <div class="max-w-[80px] sm:max-w-[120px]">
                                <img
                                    :alt="companyName"
                                    :title="companyName"
                                    class="h-8 w-auto rounded object-cover object-position"
                                    :src="logoUrl"
                                    @error="onLogoError" >
                            </div>
                        </div>
                    </router-link>

                    <hts-tabs
                        :items="menuItems"
                        :check-active="true"
                        color="main" />
                </div>

                <alerts v-if="typePage === 'ws'" />
                <admin-notification v-if="typePage === 'admin'" />
                <notifications v-if="typePage === 'ws'" />
                <hts-popover v-if="!hiddenUserMenu">
                    <menu-user
                        ref="refMenuUser"
                        :username="userName"
                        :type-page="typePage" />

                    <template #reference>
                        <div class="flex justify-start items-center h-full cursor-pointer">
                            <hts-avatar
                                v-if="typePage === 'ws'"
                                size="mini"
                                :src="avatar"
                                class="mr-1" />
                            <div :class="{ 'hidden sm:flex': typePage === 'ws' }">
                                <span class="mr-1 whitespace-nowrap sm:max-w-[200px] max-w-[58px] overflow-hidden text-ellipsis">
                                    {{ userName }}
                                </span>
                            </div>
                        </div>
                    </template>
                </hts-popover>
            </nav>
        </div>
    </div>
</template>

<script lang="ts" setup>
import AdminNotification from './admin-notifications.vue'
import Alerts from './alerts.vue'
import MenuUser from './menu-user.vue'
import Notifications from './notifications.vue'
const store = $store()
const { $formatters } = useNuxtApp()
const alertVisible = computed({
  get () {
    return store.systemAlert.visible
  },
  set (val: boolean) {
    store.systemAlert.setAlertVisible(val)
  }
})
const route = useRoute()
const isAdminRoute = computed(() => route.name?.toString().includes('admincp'))
const isTrucker = computed(() => route.name?.toString().includes('trucker'))

const emits = defineEmits(['openMenu'])
const alertContent = computed(() => store.systemAlert.content)
const alertStyle = computed(() => store.systemAlert.style)
const alertRoute = computed(() => store.systemAlert.route)
const avatar = computed(() => {
  return store.userConfig.getAvatar
})

const defaultLogoUrl = '/assets/logo.png'
const logo = computed(() => {
  return $formatters.cdnUrl(store.userConfig.getLogo)
})

const onLogoError = (event: Event) => {
  const target = event.target as HTMLImageElement

  let errorCount = target.getAttribute('data-error-count') || 0
  errorCount = Number(errorCount) // Chuyển từ chuỗi sang số

  if (errorCount < 1) {
    target.src = defaultLogoUrl
    target.setAttribute('data-error-count', '1') // Đánh dấu lần lỗi thứ 1
  } else {
    target.style.display = 'none'
  }
}

const logoUrl = computed(() => {
  return logo.value || defaultLogoUrl
})

const companyName = computed(() => {
  return store.system.company?.name || 'HWTS'
})

onMounted(() => {
  useFavicon(logoUrl.value, {
    rel: 'icon'
  })
})

const props = defineProps({
  menuItems: {
    type: Array,
    required: true
  },
  hiddenUserMenu: Boolean,
  isAdmin: {
    type: Boolean,
    default: false
  },
  typePage: {
    type: String,
    default: 'ws' // ws | admin | user
  }
})
const { menuItems, typePage } = toRefs(props)

const CShowLabel = computed(() => {
  if (!store.system.miniVariant) {
    return true
  }

  return false
})

const user = computed(() => store.userConfig.getUser || ({} as any))
const userName = computed(() => user.value.fullName)

const openMenu = () => {
  emits('openMenu')
}
</script>
